<template>
  <div id="recolecciones">
      <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="RECOLECCIONES" color="primary darken-4" dark>
            <div slot="widget-content">

              <v-layout row wrap>
                <v-flex lg12>
                  <v-card>
                   
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                      <v-data-table
                        :headers="headers"
                        :search="search"
                        :items="recolecciones"
                        :pagination.sync="pagination"
                        :rows-per-page-items="[
                          10,
                          25,
                          50,
                          { text: 'Todos', value: -1 },
                        ]"
                        class="elevation-1"
                        item-key="clienteId"
                      >
                        <template slot="items" slot-scope="props">
                          <!-- <td>
                            <v-avatar size="48">
                              <v-icon color="primary" medium
                                >account_circle</v-icon
                              >
                            </v-avatar>
                          </td> -->
                          <td>{{ props.item.folioRenta }}</td>
                          <td>{{ props.item.nombreCompletoCliente }}</td>
                          <td>{{ props.item.telefonoCliente }}</td>
                          <td>{{ props.item.telefonoSucursal }}</td>
                          <td>{{ props.item.horaRecoleccionSemana }}</td>
                          <td>{{ props.item.horaRecoleccionFinSemana }}</td>
                          <td>{{ props.item.montoTotalFinal }}</td>
                          <td>{{ props.item.montoTotalPagado }}</td>
                          <!-- <td>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="primary"
                              small
                              @click="getCliente(props.item.clienteId)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="pink"
                              small
                              @click="deleteCliente(props.item.clienteId)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td> -->
                        </template>
                        <v-alert
                          slot="no-results"
                          :value="true"
                          color="error"
                          icon="warning"
                          outline
                          >La búsqueda para "{{ search }}" no encontró
                          registros</v-alert
                        >
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>

  </div>
</template>


<script>
import VWidget from "@/components/VWidget";

import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

import rentaService from "@/services/rentaService";

export default {
  components: {
    VWidget,
    confirm,
    loadingAlert,
    snackBar
  },
  data() {
    return {
      search: "",
      pagination: {
        descending: true,
        sortBy: "folioRenta",
      },
      headers: [
        { text: "FOLIO RENTA", align: "center", value: "folioRenta" },
        { text: "CLIENTE", align: "center", value: "nombreCompletoCliente" },
        { text: "TELÉFONO CLIENTE", align: "center", value: "telefonoCliente" },
        { text: "TELÉFONO SUCURSAL", align: "center", value: "telefonoSucursal" },
        { text: "HR RECOLECCION SEMANA", align: "center", value: "horaRecoleccionSemana" },
        { text: "HR RECOLECCIÓN FIN SEMANA", align: "center", value: "horaRecoleccionFinSemana" },
        { text: "COSTO RENTA", align: "center", value: "montoTotalFinal" },
        { text: "PAGADO", align: "center", value: "montoTotalPagado" },
      ],
      recolecciones: []
    };
  },
  methods:{
    getRecolecciones() {
        console.log("Entré a recolecciones");
      let self = this;
      self.$store.state.loadingInfo.show = true;
      rentaService
        .getRecolecciones()
        .then((result) => {
          self.recolecciones = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
  }
}
</script>

